import { IonContent, IonPage, IonTitle } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router';
import { Machine, useGetMachineQuery } from '../../api/graphql/generated';
import { NestedPageHeader } from '../../components/header/page.header';
import { MachineMaintenance } from '../../components/machine/machine-maintenance';
import { useBeaconRouter } from '../../route/route.hooks';

interface RouteParams {
  id: string;
}

interface MachineDetailsPageProps {
  teamId: string;
}

const MachineMaintenancePage = (
  props: MachineDetailsPageProps
): ReactElement => {
  const { teamId } = props;
  const { i18n } = useTranslation();

  const params = useParams<RouteParams>();
  const { id } = params;

  const { data } = useGetMachineQuery({
    variables: { input: { id, teamId } },
  });

  const machine: Machine | undefined = data?.getMachine;

  const { builder } = useBeaconRouter();

  return (
    <IonPage>
      <NestedPageHeader defaultBackRoute={builder.getMachineRoute(teamId, id)}>
        <IonTitle>
          {i18n.t('common:maintenance_window')}
          <div className="subtitle">{machine?.name}</div>
        </IonTitle>
      </NestedPageHeader>
      <IonContent>
        <MachineMaintenance id={id} teamId={teamId} />
      </IonContent>
    </IonPage>
  );
};

export { MachineMaintenancePage };
